import { price as priceUtils } from '@eti/utils';
import { css } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const screenReaderOnlyStylesCSS = css`
  border: 0;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  font-size: 0.0125rem;
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
const ScreenReaderPrice = _ref => {
  let {
    id,
    price
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    className: screenReaderOnlyStylesCSS,
    id: id,
    children: priceUtils.replaceWithCurrencyName(price)
  });
};
export default ScreenReaderPrice;
//# sourceMappingURL=ScreenReaderPrice.js.map